<script setup lang="ts">
import type { Theme } from '@teemill/modules/theme-builder';
import type { Ref } from 'vue';
import { computed, inject } from 'vue';
import { App } from '@teemill/modules/app';
import { faMoon, faSunBright } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon, TmlBubble, TmlButton } from '@teemill/components';
import { cloudDark, cloudLight } from '@teemill/modules/theme-builder/themes';
import { useEvents } from '@/utils/useEvents';

const theme = inject<Ref<Theme>>('theme');

const icon = computed(() => {
  switch (theme?.value.style) {
    case 'dark':
      return faMoon;
    default:
    case 'light':
      return faSunBright;
  }
});

const events = useEvents();

const onSetTheme = () => {
  const app = App.get('teemill');

  if (theme?.value.name === 'cloudLight') {
    app.setTheme(cloudDark);
    window.localStorage.setItem('theme', 'cloudDark');
    events.user.publish('theme', 'cloudDark');
  } else {
    app.setTheme(cloudLight);
    window.localStorage.setItem('theme', 'cloudLight');
    events.user.publish('theme', 'cloudLight');
  }
};
</script>

<template>
  <TmlButton v-if="theme" @click="onSetTheme">
    <TmlBubble class="w-10 h-10 flex justify-center items-center overflow-hidden">
      <Transition name="swap" mode="out-in">
        <FontAwesomeIcon :key="theme.style" :icon="icon" class="w-5 h-5" />
      </Transition>
    </TmlBubble>
    <slot />
  </TmlButton>
</template>

<style scoped>
.swap-enter-active,
.swap-leave-active {
  transition:
    transform 150ms ease,
    opacity 150ms ease;
  transform-origin: 50% 400%;
}

.swap-enter-from {
  transform: rotate(-20deg);
  opacity: 0;
}

.swap-leave-to {
  transform: rotate(20deg);
  opacity: 0;
}
</style>
